// The greeting by time of day, shared by the vault and the brand dashboard
// (#410): "Good morning ☀️", "Good afternoon 👋", "Good evening 🌙", and
// "Still up ✨" late at night.
export const greeting = (now = new Date()): { text: string; emoji: string } => {
  const h = now.getHours();
  if (h >= 5 && h < 12) return { text: 'Good morning', emoji: '☀️' };
  if (h >= 12 && h < 18) return { text: 'Good afternoon', emoji: '👋' };
  if (h >= 18 && h < 23) return { text: 'Good evening', emoji: '🌙' };
  return { text: 'Still up', emoji: '✨' };
};
